import { render, staticRenderFns } from "./adsEditName.vue?vue&type=template&id=5d5bcca6&scoped=true"
import script from "./adsEditName.vue?vue&type=script&lang=js"
export * from "./adsEditName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5bcca6",
  null
  
)

export default component.exports